
<panel-block id="pn-required" panel-group>
  <panel-item>
    <label :for="model.idForProp('is_required')"><slot>Required</slot></label>
    <toggle-select
      :id="model.idForProp('is_required')"
      compress
      v-model="model.is_required"
    ></toggle-select>
  </panel-item>

  <panel-item v-if="model.hasOwnProperty('required_message') && model.is_required">
    <div class="sr-only">
      <label :for="model.idForProp('required_message')">Required Message</label>
    </div>
    <expandable-textarea
      v-model="model.required_message"
      :id="model.idForProp('required_message')"
      placeholder="Custom validation error message"
      class="compress"
      :is-disabled="!canConfigure"
    ></expandable-textarea>
  </panel-item>

  <panel-item v-if="isOptionRangeRequireable && model.is_required">
    <option-range
      :model="model"
      :disabled="!canConfigure"
      :min="min"
      :max="max"
    >
      <slot name="option-range-label"></slot>
    </option-range>
  </panel-item>
</panel-block>
